function searchFunc() {
    var input, filter, ul, li, a, i, txtValue, linklist;
    let searchbox = document.getElementsByClassName("search-box");
    input = document.getElementById("myInput");
    filter = input.value.toUpperCase();
    ul = document.getElementById("myUL");
    li = ul.getElementsByTagName("li");
    for (i = 0; i < li.length; i++) {
        a = li[i].getElementsByTagName("a")[0];
        txtValue = a.textContent || a.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
            li[i].style.display = "";
            li[i].onclick = function(e){
              searchbox[0].style.display="none";
              console.log(e.target.id);
              let widget_boxes = document.getElementsByClassName("widget-box");
              for(let n = 0 ;n < widget_boxes.length ; n++){
                linklist = widget_boxes[n].getElementsByClassName("list");
                for( let k = 0; k < linklist.length; k++){
                let hreflist = linklist[k].getElementsByTagName("a");
                  for(let j=0; j < hreflist.length; j++ ){
                    console.log(hreflist[j].getAttribute("data-target"))
                    if(hreflist[j].innerText.toUpperCase().includes(filter) ){
                      if(hreflist[j].getAttribute("data-target") == e.target.id){
                        hreflist[j].parentElement.parentElement.parentElement.parentElement.parentElement.scrollIntoView();
                        hreflist[j].click();
                      }
                    }
                }
              }
            }
            }
        } else {
            li[i].style.display = "none";
        }
    }
    input.onclick = function(b){
      searchbox[0].style.display="block";
    }
}